import axios from 'axios';
import { generateQueryParams } from 'utils/generateQueryParams';

export const StoriesService = {
  async getStories(groupId, page, perPage) {
    const params = generateQueryParams({
      story_group_id: groupId,
      page,
      size: perPage,
    });

    const res = await axios.get('org/v1/stories/', { params });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async createStories(payload) {
    const res = await axios.post('org/v1/stories/', payload);

    if (res.status === 201) {
      return res.data;
    }

    return Promise.reject();
  },

  async deleteStories(id) {
    const res = await axios.delete(`org/v1/stories/${id}/`);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },

  async updateStories(payload, id) {
    const res = await axios.put(`org/v1/stories/${id}/`, payload);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },
};
